import React from 'react';
import { Layout, ConfigProvider } from 'antd';
import './App.css';

// Import components
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Publications from './components/Publications';
import Education from './components/Education';
import News from './components/News';
import Contact from './components/Contact';
import Footer from './components/Footer';

const { Content } = Layout;

function App() {
  return (
    <ConfigProvider>
      <Layout className="app-layout">
        <Header />
        <Layout>
          <Content className="main-content">
            <Hero />
            <About />
            <Experience />
            <Projects />
            <Publications />
            <Education />
            <News />
            <Contact />
          </Content>
          <Footer />
        </Layout>
      </Layout>
    </ConfigProvider>
  );
}

export default App;